import CONSTANTS from '@picsio/db/src/constants';

const PD = CONSTANTS.NEW_PATH_DELIMITER;

/**
 * Filter lightboards by the current search query.
 * Empty query returns null so the tree falls back to the full list.
 * @param {Array<{ path: string }>} lightboards
 * @param {string} searchQuery
 * @returns {Array|null}
 */
export default function filterLightboards(lightboards, searchQuery) {
  if (!searchQuery) return null;

  const query = searchQuery.toLowerCase();
  return lightboards.filter((node) => node.path
    .split(PD)
    .pop()
    .toLowerCase()
    .includes(query));
}
